import * as GLOBAL_LABELS from "../labels/global";

export const LABELS = {
    [GLOBAL_LABELS.GLOBAL_DELETE]: "削除",
    [GLOBAL_LABELS.GLOBAL_CANCEL]: "キャンセル",
    [GLOBAL_LABELS.GLOBAL_UNKNOWN]: "不明",

    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE]: "โหมดทดสอบ",
    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE]: "โหมดทดสอบการผลิต",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE]: "การชำระเงินนี้อยู่ใน {mode} จะไม่มีการชำระเงินจริง",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON]: "ฉันเข้าใจ",
};

export default LABELS;
